const PERMISSIONSBYSECTIONKEY = {
  "012400": [
    {
      value: "*",
      label: "*",
    },
    {
      value: "all.brands.view",
      label: "Ver todas las marcas",
    },
    {
      value: "all.shops.view",
      label: "Ver todas las sucursales",
    },
    {
      value: "missing.uploat",
      label: "Cargar faltantes",
    },
    {
      value: "missing.download",
      label: "Descargar faltantes",
    },
    {
      value: "missing.update.status",
      label: "Actualizar estado del faltante",
    },
    {
      value: "evidence.decline",
      label: "Rechazar evidencia",
    },
    {
      value: "senders.config",
      label: "Configurar remitentes",
    },
    {
      value: "evidence.create",
      label: "Crear evidencia",
    },
    {
      value: "evidence.edit",
      label: "Editar evidencia",
    },
  ],
};

export default PERMISSIONSBYSECTIONKEY;
